import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=540ed78b&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=540ed78b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ed78b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540ed78b')) {
      api.createRecord('540ed78b', component.options)
    } else {
      api.reload('540ed78b', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=540ed78b&scoped=true&", function () {
      api.rerender('540ed78b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/PopupBox.vue"
export default component.exports